module.exports = __webpack_public_path__ + "img/stena19.882ceb90.jpg";